/* eslint-disable no-unused-vars */
export const enum Page {
	Home = 'Home',
	AIAnalyst = 'AIAnalyst',
	Finder = 'Finder',
	Explainer = 'Explainer',
	Contacts = 'Contacts',
	Segments = 'Segments',
	Campaigns = 'Campaigns',
	CXInsights = 'CXInsights',
	DataInsights = 'DataInsights',
	Help = 'Help',
	OpsInsights = 'OpsInsights',
	ProfitInsights = 'ProfitInsights',
	CRMInsights = 'CRMInsights',
	D2CDashboard = 'D2CDashboard',
	RetailDashboard = 'RetailDashboard',
	ConversionInsights = 'ConversionInsights',
	ProductInsights = 'ProductInsights',
	Acquisition = 'Acquisition',
	Retention = 'Retention',
	Subscription = 'Subscription',
	Customer = 'Customer',
	Settings = 'Settings',
	Dashboard = 'Dashboard',
	ExportCleaner = 'ExportCleaner',
	CACSignals = 'CACSignals',
	LTVSignals = 'LTVSignals',
	ConversionSignals = 'ConversionSignals',
	ExperienceSignals = 'ExperienceSignals',
	PerformanceSignals = 'PerformanceSignals',
	GrowthModel = 'GrowthModel',
	JourneyExplorer = 'JourneyExplorer',
}
